module.exports = __webpack_public_path__ + "static/media/jeremy_fiance.8dd931de.jpeg";